import { render, staticRenderFns } from "./AddHelpdeskLogin.vue?vue&type=template&id=cf50f81a&"
import script from "./AddHelpdeskLogin.vue?vue&type=script&lang=js&"
export * from "./AddHelpdeskLogin.vue?vue&type=script&lang=js&"
import style0 from "./AddHelpdeskLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports